import useSWRImmutable from 'swr'
import fetcher from './fetcher'

export default function useRevenueByGeographics(id) {
  const { data, error, isLoading } = useSWRImmutable(`/react/revenue/by-geographics?stock_id=${id}`, fetcher)

  return {
    revenueByGeographics: data,
    isLoading,
    error
  }
}